import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { galleryListQueries } from '@/services/galleryManagement/galleryManagement.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useDeleteHostGallery = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation('deleteHostGallery', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...galleryListQueries.all()] });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync: mutation.mutateAsync };
};
